<script>
    /** 1 | 2 — dos columnas en pantallas anchas */
    export let columns = 1
</script>

<dl class="details-fields" class:details-fields--cols-2={columns === 2}>
    <slot />
</dl>
